export default __webpack_public_path__ + "static/media/money-back@3x.4988315d.png";